<template>
    <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="296.000000pt"
        height="256.000000pt"
        viewBox="0 0 296.000000 256.000000"
        preserveAspectRatio="xMidYMid meet"
    >
        <g transform="translate(0.000000,256.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
            <path
                d="M1894 2212 c-6 -4 -99 -141 -207 -304 -108 -164 -200 -298 -204 -298
-4 1 -51 61 -103 135 l-95 134 -188 1 c-148 0 -187 -3 -181 -12 4 -7 69 -94
143 -193 75 -99 155 -205 177 -236 l42 -57 -171 -235 c-95 -129 -261 -356
-369 -505 -109 -149 -198 -273 -198 -276 0 -3 80 -6 179 -6 l178 0 148 217
c82 120 182 268 224 328 41 61 99 145 128 187 l54 78 61 -83 c33 -45 97 -130
141 -189 l80 -108 189 0 c149 0 188 3 182 13 -5 6 -101 132 -215 278 -114 146
-212 275 -219 286 -13 21 9 52 481 683 64 85 114 158 112 163 -5 9 -354 9
-369 -1z"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: "TicimaxIcon",
};
</script>

<style scoped></style>
